@if (!options) {
  <div>Requires dependent selection ...</div>
}

@if (options) {
  <mat-form-field class="example-full-width">
    <mat-select [(ngModel)]="selectedOption" [disabled]="!editMode">
      @for (option of options; track option) {
        <mat-option [value]="option" (onSelectionChange)="onOptionChange(option, $event)">
          {{ option }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (selectedOption) {
  <app-nested-panel-form-field
    [fields]="fields"
    [canAdd]="false"
    [editMode]="editMode"
    [fieldConfig]="selectedFieldConfig"
    [formGroup]="formGroup"
    [(data)]="selectedOptionData.data"></app-nested-panel-form-field>
}
